import React from 'react';
import { useParams } from 'react-router-dom';

import { useWaypointTemplateRawQuery } from '@dashboard/generated/wp/platform';
import { Paper } from '@mui/material';

export default function EmailMessageTemplateRaw() {
  const id = useParams<{ id: string }>().id!;
  const { data } = useWaypointTemplateRawQuery({ variables: { id } });

  const model = data?.WaypointTemplate;

  if (model === undefined) {
    return null;
  }

  return (
    <Paper>
      <pre style={{ margin: 0, padding: 24 }}>
        <strong>subject: </strong>
        {model.activeConfiguration.rawSubject}
      </pre>
      <pre style={{ margin: 0, padding: 24 }}>
        <strong>body: </strong>
        <br />
        {model.activeConfiguration.rawHtml}
      </pre>
    </Paper>
  );
}
